export default __webpack_public_path__ + "static/media/exit.b1e7e80f.svg";